import React, { useState, useEffect } from "react";
import {  DatePicker, Input, Switch } from "antd";
import moment from "moment";
import { ErrorToast } from "../../../../../widgets/AppToast";
import { post } from "../../../../../services/services";
import { ApiURL } from "../../../../../services/apiConstants";
import UnitWithInput from "../../../../../components/UnitWithInput";
import {
  currentUnits,
  lengthUnits,
  loadUnits,
  pressureUnits,
  speedUnits,
  temperatureUnits,
} from "../../../../../Data/data";


const parameterConfig = {
  total_operating_hours: { label: "Total Operating Hours", unitList: [] },
  hydraulic_oil_pressure: { label: "Hydraulic Oil Pressure", unitList: pressureUnits },
  hydraulic_oil_temperature: { label: "Hydraulic Oil Temperature", unitList: temperatureUnits },
  motor_current: { label: "Motor Current", unitList: currentUnits },
  motor_temperature: { label: "Motor Temperature", unitList: temperatureUnits },
  actual_load_weight: { label: "Actual Load Weight", unitList: loadUnits },
  percentage_rated_capacity_used: { label: "Rated Capacity Used (%)", unitList: [] },
  radius_of_load: { label: "Radius of Load", unitList: lengthUnits },
  load_moment: { label: "Load Moment", unitList: [] },
  boom_angle: { label: "Boom Angle", unitList: [] },
  boom_length: { label: "Boom Length", unitList: lengthUnits },
  slew_angle: { label: "Slew Angle", unitList: [] },
  fly_jib_angle: { label: "Fly Jib Angle", unitList: [] },
  fly_jib_length: { label: "Fly Jib Length", unitList: lengthUnits },
  wind_speed: { label: "Wind Speed", unitList: speedUnits },
  vessel_heel: { label: "Vessel Heel", unitList: [] },
  vessel_trim: { label: "Vessel Trim", unitList: [] },
  number_of_lifting_cycles: { label: "Lifting Cycles", unitList: [] },
  idle_time: { label: "Idle Time", unitList: [] },
  hoisting_motions: { label: "Hoisting Motions", unitList: [] },
  luffing_motions: { label: "Luffing Motions", unitList: [] },
  slewing_motions: { label: "Slewing Motions", unitList: [] },
  operation: { label: "Operation", unitList: [] },
  operation_hours: { label: "Operation Hours", unitList: [] },
  total_operation_hours: { label: "Total Operation Hours", unitList: [] },
};

export const CargoCranCom = ({ eng_log_basic_id, _items }) => {
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    logDate: moment().format("YYYY-MM-DD HH:mm:ss"),
    parameters: {},
    otherParams: {},
  });
  const [checked, setChecked] = useState(false);
  const [updateStatus, setUpdateStatus] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(false);

  useEffect(() => {
      // Initialize parameters from _items.selected_parameters
    const initialParameters = (_items?.selected_parameters || []).reduce((acc, param) => {
      if (parameterConfig[param]) {
        acc[param] = { value: "", unit: parameterConfig[param].unitList[0] || "" };
      }
      return acc;
    }, {});

    // Initialize other parameters from _items.other_parameters
    const initialOtherParams = (_items?.other_parameters || []).reduce((acc, param) => {
      acc[param.name] = { value: param.value || "", unit: param.unit || "" };
      return acc;
    }, {});

    setFormData((prev) => ({
      ...prev,
      parameters: initialParameters,
      otherParams: initialOtherParams,
    }));

      VIEW_IGG_LOGBOOK_API(_items.id);
    
  }, [_items?.id]);

  // Handle date/time change
  const onChangeDateTime = (value) => {
    setFormData((prev) => ({
      ...prev,
      logDate: value ? value.format("YYYY-MM-DD HH:mm:ss") : null,
    }));
  };

  // Handle parameter value/unit change
  const updateParameter = (param, field, value) => {
    setFormData((prev) => ({
      ...prev,
      parameters: {
        ...prev.parameters,
        [param]: { ...prev.parameters[param], [field]: value },
      },
    }));
  };

  // Handle other parameter value/unit change
  const updateOtherParam = (name, field, value) => {
    setFormData((prev) => ({
      ...prev,
      otherParams: {
        ...prev.otherParams,
        [name]: { ...prev.otherParams[name], [field]: value },
      },
    }));
  };


  // API to view logbook details
  const VIEW_IGG_LOGBOOK_API = async (crane_id, staff_dashboard) => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("crane_id", crane_id);
      FORM_DATA.append("eng_log_basic_id", eng_log_basic_id);
      FORM_DATA.append("voyage_id", staff_dashboard?.voyage_details?.[0]?.id);
      post(ApiURL.edit_view_carne_info_machinery_com, FORM_DATA).then((res) => {
        if (res?.status === true) {
          const craneData = res?.response_data;
          setUpdateStatus(craneData?.complete_status || false);
          setSubmitStatus(true);

          setChecked(craneData?.crane_on_off || false);

          const parameters = Object.keys(craneData?.selected_parameters || {}).reduce(
            (acc, param) => {
              const paramData = craneData.selected_parameters[param] || { value: "", unit: "" };
              acc[param] = {
                value: paramData.value !== undefined ? paramData.value.toString() : "0",
                unit: paramData.unit || parameterConfig[param]?.unitList[0] || "",
              };
              return acc;
            },
            {}
          );

          setFormData((prev) => {
            return {
              ...prev,
              logDate: craneData?.date_time_log || moment().format("YYYY-MM-DD HH:mm:ss"),
              parameters,

              otherParams:
                craneData?.other_parameters && Object.keys(craneData.other_parameters).length
                  ? Object.keys(craneData.other_parameters).reduce((acc, key) => {
                      const paramData = craneData.other_parameters[key] || { value: "", unit: "" };
                      acc[key] = {
                        value: paramData.value !== undefined ? paramData.value.toString() : "",
                        unit: paramData.unit || "",
                      };
                      return acc;
                    }, {})
                  : prev.otherParams,
            };
          });
        } else {
          setErrors(res?.errors || {});
          ErrorToast("Error", "Failed to fetch logbook details.");
        }
      });
    } catch (error) {
      console.error("Error fetching IGG logbook:", error);
      ErrorToast("Error", "An error occurred while fetching logbook details.");
    }
  };

  // Render
  return (
    <>
      <div className="row custom-box">
        <div className="col-4">
          <b style={{ color: "#161515", fontSize: "14px" }}>Crane Name: {_items?.crane_name}</b>
        </div>
        <div className="col-4">
          <b style={{ color: "#161515", fontSize: "14px" }}>Crane Model: {_items?.crane_name}</b>
        </div>
        <div className="col-4">
          <b style={{ color: "#161515", fontSize: "14px" }}>Crane Maker: {_items?.crane_maker}</b>
        </div>
        <div className="col-4">
          <b style={{ color: "#161515", fontSize: "14px" }}>Crane ID: {_items?.id}</b>
        </div>
        <div className="col-2">
          <Switch
            disabled={submitStatus}
            checked={checked}
            // onChange={(value) => {
            //   setChecked(value);
            //   updateStatus
            //     ? UPDATE_IGG_LOGBOOK_API(_items?.id, "0", value)
            //     : ADD_IGG_LOGBOOK_API(_items?.id, value);
            // }}
            checkedChildren="On"
            unCheckedChildren="Off"
            style={{ backgroundColor: checked ? "green" : "red" }}
          />
        </div>
      </div>

      {checked && (
        <>
          {/* Date & Time */}
          <div className="row">
            <div className="col-4">
              <div className="input-box">
                <label>Date & Time</label>
                <DatePicker
                  showTime
                  format="YYYY-MM-DD HH:mm:ss"
                  placeholder="Select Date & Time"
                  value={formData.logDate ? moment(formData.logDate, "YYYY-MM-DD HH:mm:ss") : null}
                  onChange={onChangeDateTime}
                  style={{ width: "100%" }}
                  disabled={submitStatus}
                  className="custom-input"
                />
                {errors.date_time_log && <p className="error-text">{errors.date_time_log}</p>}
              </div>
            </div>
          </div>

          {/* Selected Parameters */}
          <h4>Selected Parameters</h4>
          {(() => {
            const rows = [];
            const inputs = (_items?.selected_parameters || [])
              .filter((param) => parameterConfig[param])
              .map((param) => ({
                type: "selectedParam",
                name: param,
                config: parameterConfig[param],
                value: formData.parameters[param]?.value || "",
                unit: formData.parameters[param]?.unit || "",
              }));

            for (let i = 0; i < inputs.length; i += 3) {
              const group = inputs.slice(i, i + 3);
              rows.push(
                <div className="row" key={`param-row-${i}`}>
                  {group.map((input) => (
                    <div className="col-4" key={input.name}>
                      {input.config.unitList?.length ? (
                        <UnitWithInput
                          label={input.config.label}
                          value={input.value}
                          onChange={(e) => updateParameter(input.name, "value", e.target.value)}
                          unit={input.unit}
                          onUnitChange={(e) => updateParameter(input.name, "unit", e.target.value)}
                          disabled={submitStatus}
                          error={
                            errors[`pr_${input.name.replace(/([A-Z])/g, "_$1").toLowerCase()}`]
                          }
                          unitList={input.config.unitList}
                          className="custom-input"
                        />
                      ) : (
                        <div className="input-box">
                          <label>{input.config.label}</label>
                          <Input
                            disabled={submitStatus}
                            value={input.value}
                            placeholder={input.config.label}
                            onChange={(e) => updateParameter(input.name, "value", e.target.value)}
                            className={`custom-input ${
                              errors[`pr_${input.name.replace(/([A-Z])/g, "_$1").toLowerCase()}`]
                                ? "error"
                                : ""
                            }`}
                          />
                          {errors[`pr_${input.name.replace(/([A-Z])/g, "_$1").toLowerCase()}`] && (
                            <p className="error-text">
                              {errors[`pr_${input.name.replace(/([A-Z])/g, "_$1").toLowerCase()}`]}
                            </p>
                          )}
                        </div>
                      )}
                    </div>
                  ))}
                  {group.length < 3 &&
                    Array.from({ length: 3 - group.length }).map((_, idx) => (
                      <div className="col-4" key={`empty-param-${i}-${idx}`}></div>
                    ))}
                </div>
              );
            }
            return rows;
          })()}

          {/* Other Parameters */}
          <h4>Other Parameters</h4>
          {(() => {
            const rows = [];
            const otherParamsArray = Object.entries(formData.otherParams || {});
            for (let i = 0; i < otherParamsArray.length; i += 3) {
              const group = otherParamsArray.slice(i, i + 3);
              rows.push(
                <div className="row" key={`other-row-${i}`}>
                  {group.map(([name, { value, unit }]) => (
                    <div className="col-4" key={name}>
                      <UnitWithInput
                        label={name}
                        value={value}
                        onChange={(e) => updateOtherParam(name, "value", e.target.value)}
                        unit={unit}
                        onUnitChange={(e) => updateOtherParam(name, "unit", e.target.value)}
                        disabled={submitStatus}
                        unitList={[]} // No specific unit list for other parameters
                        className="custom-input"
                      />
                    </div>
                  ))}
                  {group.length < 3 &&
                    Array.from({ length: 3 - group.length }).map((_, idx) => (
                      <div className="col-4" key={`empty-other-${i}-${idx}`}></div>
                    ))}
                </div>
              );
            }
            return rows;
          })()}

       
        </>
      )}
    </>
  );
};
